import React from 'react';
import styled from 'styled-components';
import { getColorHex } from './taskTypeColors';
import Icon from './Icon';

const Container = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  margin-right: 0.5rem;
  flex-shrink: 0;
`;

function TaskTypeIcon({ icon, color }) {
  return (
    <Container>
      <Icon icon={icon} color={getColorHex(color)} />
    </Container>
  );
}

export default TaskTypeIcon;
